

export default {
  metodeList: [],
  jenisList: [],
  tutorialList: [],
  totalRecords: 0,
  totalFiltered: 0,
  totalMetode: 0,
  totalJenis: 0,
  totalTP: 0,
  totalNonLogin: 0
}
